'use strict';

(function () {
    const self = Fotobook.provider = {

        /**
         * Вылогиниться из провайдера
         */
        logout() {
            const code = $('#import').attr('data-storage');
            Fotobook.$http.post('/user/hybrid-auth/logout', {
                data: {
                    provider: code,
                },
            }).then((response) => {
                if (response.data !== undefined) {
                    if (response.data.logoutUrl.trim() === '') {
                        // логаут на фронтенде не  поддерживается
                        Fotobook.dialog.alert(t('photobook-js-provider-logoutNotSupported'), { title: t('photobook-js-warning') });
                        return false;
                    }
                    $('<iframe>', {
                        src: response.data.logoutUrl,
                        name: 'hideLogoutProviderPage',
                        style: 'display:none;',
                    }).appendTo('body').on('load', () => {
                        const $list = $('.providers-section-list');
                        Fotobook.import.providerClick('.pc-provider .provider').then(() => {
                            $list.find('.provider.connected').removeClass('connected').addClass('not-connected');
                        });
                    });
                }
            });
        },

        /** Диалог лицензионного соглашения Гугл */
        acceptGooglePhotosPolicy(acceptOnlyBtn = false) {
            const options = {
                title: t('photobook-googlePhotos-policy-dialog-title'),
                height: 600,
                width: 600,
                buttonResolve: t('photobook-js-buttonsOk'),
                buttonReject: t('photobook-js-buttonsCancel'),
                dialogClass: 'gppDialog',
                resolved: Fotobook.store.state.user.googlePhotoPolicyAccepted,
                showButtonReject: !acceptOnlyBtn,
                open() {
                    Fotobook.DynaResourcesManager.get(Fotobook.DynaResource.GOOGLE_PHOTOS_POLICY).then((content) => {
                        $('.gppPolicyText').text(content);
                    });
                    if (acceptOnlyBtn) {
                        return;
                    }
                    $(this)
                        .parent()
                        .find('.fotobook-dialogbutton-resolve')
                        .attr('disabled', true)
                        .addClass('ui-state-disabled');
                },
            };
            const policyAccept = t('photobook-googlePhotos-policy-accept');
            const hideClass = acceptOnlyBtn ? 'hide' : '';
            const content = `<div class="gppPolicyText"></div><div class="acceptGppParent ${hideClass}"><input type="checkbox" name="acceptGpp" id="acceptGpp" value><label for="acceptGpp" class="styled-label uniform-sprite-image-ba before">${policyAccept}</label></div>`;

            return Fotobook.dialog.confirm(content, options);
        },
    };

    $(document)
        .on('click', '.logoutProvider', self.logout)
    ;
})();
